module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/shoppingcart/shoppingcart.component.scss
// module id = ./src/app/shared/components/shoppingcart/shoppingcart.component.scss
// module chunks = main